import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import { Avatar, Grid } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import ButtonComponent from "../Button";

const DeletePopUp = ({ open, setOpen, funcToExecute }) => {

    const handleClose = () => {
        setOpen(false);
    };
    return (

        <Dialog open={open} onClose={handleClose} PaperProps={{
            sx: {
                borderRadius: "1.34rem",
                padding: "8px"
            },
        }}>

            <ClearIcon
                fontSize="small"
                style={{
                    position: "absolute",
                    cursor: "pointer",
                    color: "grey",
                    top: 11,
                    right: 10,
                }}
                onClick={handleClose}
            />
            <DialogTitle
                style={{ textAlign: "center" }}>Delete Lead
            </DialogTitle>

            <Grid
                style={{
                    borderBottom: "0.1rem solid lightgrey",
                }}
            ></Grid>


            <DialogContent

            >
                <DialogContentText style={{ textAlign: "center" }}>
                    Are you sure you want to delete this?
                </DialogContentText>
            </DialogContent>


            <DialogActions
                style={{ display: "flex", justifyContent: "center" }}
            >
                <ButtonComponent
                    name="No"
                    backgroundColor={"rgba(225, 225, 225, 1)"}
                    color={"Black"}
                    borderRadius={"100px"}
                    width={"159px"}
                    onClick={handleClose}
                />

                <ButtonComponent
                    name="Yes"
                    borderRadius={"100px"}
                    width={"159px"}
                    onClick={() => {
                        funcToExecute();
                        handleClose();
                    }}

                />



            </DialogActions>
        </Dialog>

    );
};

export default DeletePopUp;
